import Airtable from "airtable";
export default new Airtable({apiKey:process.env.REACT_APP_AIRTABLE_API_KEY}).base(process.env.REACT_APP_AIRTABLE_BASE_ID);